module.exports = __webpack_public_path__ + "img/footer.e7b3fc7d.png";